<template>
  <el-dialog title="患儿注册详情" :visible.sync="showDialog" width="890px" @close='closeDetail' :close-on-click-modal="false">
    <div style="text-align: right; padding: 0 16px 16px 0; background: white;">
      <el-button :loading="loading" icon="el-icon-refresh" type="primary" size="small" v-if="detailForm1.isTimeout==1 && detailForm1.isRestartAccount==1" @click="reuse">账号重启</el-button>
      <el-button :loading="loading" icon="el-icon-circle-check" type="primary" size="small" v-if="(detailType==0||detailType==4)&&detailForm1.isTimeout==0" @click="isCaptchaMatch">提交</el-button>
      <el-button :loading="loading" icon="el-icon-sort" v-if="detailForm1.apprStatus == 0" size="small" type="primary" @click="convertToHospitalProxy">注册转代申请</el-button>
    </div>
    <div style="padding: 16px;">
      <div class="backed" v-if="detailForm1.apprStatus == 3 || detailForm1.apprStatus == 4">
        <img src="/static/err-icon.png" alt="" />
        <span class="back-title">{{ detailForm1.apprStatus==4?'退回':'拒绝' }}原因：</span>
        <span class="back-msg">{{ detailForm1.apprOpinion }}</span>
      </div>
      <dialogPanel style="margin-bottom: 0px;">
        <ChapterHead :title="`患儿编号：${detailForm1.childId || ''}`">
          <template #extra>
            <div class="r-status">
              <img src="/static/status-icon.png" style="width: 15px;height: 15px;margin-right: 6px; vertical-align: middle;" alt="">
              <span v-if="detailForm1.apprStatus==8" style="font-size: 16px; vertical-align: middle;color: #dc243e;">相似患儿检验中，请联系业务人员</span>
              <span v-else style="font-size: 16px; vertical-align: middle;">{{detailForm1.isTurnHospital == 1 && detailForm1.helpStatus == 0 ? '转院' : detailForm1.helpStatusText}}</span>
            </div>
          </template>
        </ChapterHead>
        <el-form :inline="true" :model="detailForm1" :rules="rules" class="demo-form-inline" ref="ruleForm3">
          <el-row>
            <el-col :span="12">
              <el-form-item label="患儿姓名" prop="childName">
                <el-input v-model="detailForm1.childName" disabled size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="sexText">
                <el-input v-model="detailForm1.sexText" disabled size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker v-model="detailForm1.birthday" size="small" type="date" placeholder="选择时间" :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户口所在地" prop="locationArr">
                <LocationCascader v-model="detailForm1.location" :options="[{
                    value: detailForm1.province,
                    label: detailForm1.provinceText,
                    leaf: false,
                    children: [{
                      value: detailForm1.city,
                      label: detailForm1.cityText,
                      leaf: false,
                      valueParentId: detailForm1.province,
                      children: [{
                        value: detailForm1.county,
                        label: detailForm1.countyText,
                        leaf: true,
                        valueParentId: detailForm1.city
                      }]
                    }]
                  }]" :disabled="true">
                </LocationCascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否有身份证" size="small" prop="hasIdNumber">
                <el-radio v-model="detailForm1.hasIdNumber" disabled :label="1">是</el-radio>
                <el-radio v-model="detailForm1.hasIdNumber" disabled :label="0">否</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="detailForm1.hasIdNumber == 1">
              <el-form-item label="身份证号">
                <el-input v-model="detailForm1.idNumber" disabled size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="救助医院" prop="hospitalId">
                <HospitalSelect v-model="detailForm1.hospitalId" @change="hospitalChange" :disabled="true"></HospitalSelect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="病种" prop="diseasesIdList">
                <DiseaseCascader v-model="detailForm1.diseasesIdList"  v-if="detailForm1.helpStatus!=1" :multiple="true" :hospitalId="detailForm1.hospitalId"
                  :disabled="disabledB||detailForm1.isTimeout==1 || detailForm1.apprStatus== 8"  @change="changeDisease">
                </DiseaseCascader>
                <el-input :value="detailForm1.diseasesNameSet" v-else disabled size="small"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col v-if="detailForm1.initialProject == 'AY1001'" :span="12">
              <el-form-item label="病种类型" prop="diseasesType">
                <DictionarySelect v-model="detailForm1.diseasesType" :lazy="true"
                  :disabled="disabledB||detailForm1.isTimeout==1" tableCode="DISEASES_TYPE" />
              </el-form-item>
            </el-col> -->
          </el-row>


          <el-row>
            <el-col :span="12">
              <el-form-item label="单次/分期" prop="quotaType">
                <el-radio-group
                  v-model="detailForm1.quotaType"
                  @change="changePeriod"
                  :disabled="disabledQuotaType || isAllowStages == 0 || detailForm1.isTimeout == 1 || detailForm1.helpStatus==1 || detailForm1.apprStatus== 8">
                  <el-radio :label="0">单次</el-radio>
                  <el-radio :label="1">分期</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="期数" prop="totalStages">
                <el-input v-if="isAngleProject" value="-" disabled size="small"></el-input>
                <el-input v-else v-model="detailForm1.totalStages" disabled size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="住院号" prop="inHospitalNo" :rules="[{required: detailForm1.isAuto == 1, message: '请输入住院号', trigger: 'blur' }]">
                <el-input v-model="detailForm1.inHospitalNo" placeholder="-" :disabled="disabledB||detailForm1.isTimeout==1 || detailForm1.apprStatus== 8" size="small"></el-input>
              </el-form-item>
            </el-col>
	          <el-col :span="12" v-if="detailForm1.isShowInHospitalTime	== 1">
		          <el-form-item label="入院时间" prop="inHospitalTime" :rules="[{required: detailForm1.isShowInHospitalTime == 1, message: '请输入入院时间', trigger: 'blur' }]">
			          <el-date-picker v-model="detailForm1.inHospitalTime" size="small" type="date" placeholder="-" :disabled="disabledB||detailForm1.isTimeout==1 || detailForm1.apprStatus== 8" format="yyyy-MM-dd" value-format="timestamp">
			          </el-date-picker>
		          </el-form-item>
	          </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="detailForm1.isAuto==1">
              <el-form-item v-if="detailForm1.isShowInHospitalNumber == 1" label="住院流水号" prop="inHospitalSerialNo" :rules="[{required: detailForm1.isShowInHospitalNumber == 1, message: '请输入住院流水号', trigger: 'blur' }]">
                <el-input v-model="detailForm1.inHospitalSerialNo" placeholder="-"  size="small" :disabled="disabledB||detailForm1.isTimeout==1 || detailForm1.apprStatus== 8"></el-input>
              </el-form-item>
              <el-form-item v-if="detailForm1.isShowInHospitalTime == 1 && disabledB && detailForm1.isShowInHospitalNumber != 1" label="住院流水号" prop="inHospitalSerialNo">
                <el-input v-model="detailForm1.inHospitalSerialNo" placeholder="-"  size="small" :disabled="disabledB||detailForm1.isTimeout==1 || detailForm1.apprStatus== 8"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="12">
              <el-form-item label="登录手机号" prop="loginAccount">
                <el-input v-model="detailForm1.loginAccount" :disabled="disabledB||detailForm1.isTimeout==1 || detailForm1.apprStatus== 8" size="small">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="[0,4].indexOf(detailForm1.helpStatus) > -1 &&hasLoginAccount!=detailForm1.loginAccount">
              <el-form-item label="验证码" class="getMsg-box" prop="captcha">
                <MsgCodeInput v-model="detailForm1.captcha" :tel="detailForm1.loginAccount"></MsgCodeInput>
                <!-- <MsgCodeInput @msgCodeValue="msgCodeValue" :tel="detailForm1.loginAccount"></MsgCodeInput> -->
    <!--            <el-input v-model="detailForm1.captcha" placeholder="验证码" size="small"></el-input>-->
    <!--            <div @click="sendCode" class="codeMsg">{{codeText}}</div>-->
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="detailForm1.loginChannel === '3' && detailForm1.tiktokAuthCode">
              <el-form-item label="抖音授权码" prop="tiktokAuthCode" class="tiktokClass">
                <el-input v-model="detailForm1.tiktokAuthCode" disabled size="small"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="登录方式" prop="loginChannel">
                <el-radio-group v-model="detailForm1.loginChannel" :disabled="true">
                  <el-radio label="1">微信</el-radio>
                  <el-radio label="2">支付宝</el-radio>
                  <el-radio label="3">抖音</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="disabledB" prop="registerTime">
              <el-form-item label="注册时间">
                <el-date-picker v-model="detailForm1.registerTime" disabled size="small"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <ChapterHead v-if="isWelfareBabyType == 1" :level="2" :showWarning="true">
            <span>支付宝相关信息</span>
            <span slot="warning">所选病种中包含公益宝贝病种，请填写支付宝相关信息。</span>
          </ChapterHead>
          <el-row v-if="isWelfareBabyType == 1">
            <el-col :span="12">
              <el-form-item label="支付宝姓名" prop="loginUserName">
                <el-input placeholder="请输入支付宝姓名" :disabled="disabledB||detailForm1.isTimeout==1" size="small"
                  v-model="detailForm1.loginUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付宝身份证" prop="loginIdNumber">
                <el-input placeholder="请输入支付宝身份证" :disabled="disabledB||detailForm1.isTimeout==1" size="small"
                  v-model="detailForm1.loginIdNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付宝UID" prop="loginUserId">
                <el-input  :disabled="disabledB||detailForm1.isTimeout==1" size="small"
                  v-model="detailForm1.OpenIdAli || '-'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            <el-form-item label="与患儿关系" prop="loginRelation">
              <DictionarySelect
                v-model="detailForm1.loginRelation"
                tableCode="CHILD_RELATION"
                :lazy="true"
                :disabled="disabledB||detailForm1.isTimeout==1">
              </DictionarySelect>
            </el-form-item>
          </el-col>
          </el-row>
        </el-form>
<!--        <div slot="footer" class="dialog-footer" style="text-align: center;">-->
<!--          <el-button :loading="loading" type="primary" v-if="detailForm1.isTimeout==1" @click="reuse">账号重启</el-button>-->

<!--          <el-button :loading="loading" type="primary" v-if="detailType==0&&detailForm1.isTimeout==0" @click="isCaptchaMatch">提交</el-button>-->
<!--          &lt;!&ndash; <el-button :loading="loading" type="primary" v-if="detailType==0&&detailForm1.isTimeout==0" @click="saveRequest">暂存</el-button> &ndash;&gt;-->
<!--          <el-button :loading="loading" v-if="detailForm1.apprStatus == 0" type="primary" @click="convertToHospitalProxy">注册转代申请</el-button>-->
<!--          <el-button :loading="loading" @click="closeDetail(false)">取消</el-button>-->
<!--        </div>-->
      </dialogPanel>
    </div>
    <!-- <div slot="footer" class="dialog-footer" style="text-align: center;"> -->
      <!-- <el-button :loading="loading" type="primary" v-if="detailForm1.isTimeout==1" @click="reuse">账号重启</el-button>
      <el-button :loading="loading" type="primary" v-if="detailType==0&&detailForm1.isTimeout==0" @click="isCaptchaMatch">提交</el-button>
      <el-button :loading="loading" v-if="detailForm1.apprStatus == 0" type="primary" @click="convertToHospitalProxy">注册转代申请</el-button> -->
      <!-- <el-button :loading="loading" type="primary" v-if="detailType==0&&detailForm1.isTimeout==0" @click="saveRequest">暂存</el-button> -->
<!--      <el-button :loading="loading" @click="closeDetail(false)">取消</el-button>-->
    <!-- </div> -->
  </el-dialog>
</template>

<script>
  import {
    convertToHospitalProxy,
    parentAccountReuse,
    saveRequestApi,
    sbumitRequestApi,
    isCaptchaMatchApi,
    getHelpRequestDataById,
    uniqueInHospitalSerialNo,
    uniqueInHospitalNo
  } from "@/util/api";
  import ChapterHead from "@/components/business/ChapterHead.vue"
  import LocationCascader from "@/components/business/LocationCascader.vue"
  import DiseaseCascader from "@/components/business/DiseaseCascader.vue"
  import HospitalSelect from "@/components/business/HospitalSelect";
  import DictionarySelect from "@/components/business/DictionarySelect.vue"
  import MsgCodeInput from "@/components/business/MsgCodeInput";
  import dialogPanel from "@/components/business/dialogPanel";
  import MyCollapse from "@/components/business/MyCollapse";

  export default {
    components: {
      ChapterHead,
      LocationCascader,
      DiseaseCascader,
      MsgCodeInput,
      DictionarySelect,
      dialogPanel,
      MyCollapse,
      HospitalSelect
    },
    props: {
      detailDialog: false,
      detailType: {
        type: Number,
        value: '0'
      },
      helpReqId: String
    },
    created() {
      this.helpRequestDataById()
    },
    watch: {
      detailDialog() {
        this.showDialog = this.detailDialog;
      },
      detailType() {
        this.showDialog = (this.detailType == 0 || this.detailType == 4 ? false : true)
      },
      // 'detailForm1.quotaType': {
      //   handler(newValue) {
      //     if (newValue == 0) {
      //       this.detailForm1.totalStages = 1;
      //     } else if (newValue) {
      //       this.detailForm1.totalStages = this.detailForm1.totalStages > 1 ? this.detailForm1.totalStages : 3;
      //     }
      //   }
      // }
    },
    data() {
      var idCard = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入身份证号'));
        } else {
          var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!p.test(value)) {
            callback('身份证格式不正确')
          }
        }
        callback()
      };
      var phoneVt = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入手机号'));
        } else {
          var p = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
          if (!p.test(value)) {
            callback('手机号格式不正确')
          }
        }
        callback()
      };
      let _this = this;
      return {
        totalStagesTemp: null,
        quotaTypeTemp: null,
        curStagesTemp: null,
        loading: false,
        hasLoginAccount:'',
        isAllowStages:0,
        detailForm1: {
          captcha: null,
          quotaType: null
        },
        initialProject: null,
        codeText: '获取验证码', //发送验证码文字
        countDown: 60, //多少秒后可重新发送
        showDialog: this.detailDialog,
        disabledQuotaType: this.detailType == 0 || this.detailType == 4 ? false : true,
        disabledB: this.detailType == 0 || this.detailType == 4 ? false : true,
        locationArr: [],
        isWelfareBabyType: 0, // 是否是公益宝贝
        isAngleProject: false, // 是否天使项目
        rules: {
          quotaType: [{
            required: true,
            message: '请选择单次/分期',
            trigger: 'change'
          }],
          childName: [{
            required: true,
            message: '请输入患儿姓名',
            trigger: 'blur'
          }],
          sex: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          hasIdNumber: [{
            required: true,
            message: '是否持有身份证',
            trigger: 'change'
          }],
          idNumber: [{
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          }, {
            validator: idCard,
            trigger: 'blur'
          }],
          county: [{
            required: true,
            message: '请选择户口所在地',
            trigger: 'blur'
          }],
          birthday: [{
            required: true,
            message: '请选择出生日期',
            trigger: 'blur'
          }],
          hospitalId: [{
            required: true,
            message: '请选择救助医院',
            trigger: 'blur'
          }],
          diseasesIdList: [{
            required: true,
            message: '请选择病种',
            trigger: 'change'
          }],
          // totalStages: [{
          //   required: true,
          //   message: '请输入期数',
          //   trigger: 'change'
          // }, {
          //   validator (rule, value, callback) {
          //     callback('根据治疗情况，可联系管理员修改！');
          //   },
          //   trigger: 'change'
          // }],
          // diseasesType: [{
          //   required: true,
          //   message: '请选择病种类型',
          //   trigger: 'change'
          // }],
          loginAccount: [{
            required: true,
            message: '请输入手机号',
            trigger: 'change'
          }, {
            validator: phoneVt,
            trigger: 'blur'
          }],
          captcha: [{
            required: true,
            message: '请输入验证码',
            trigger: 'change'
          }],
          loginChannel: [{
            required: true,
            message: '请选择登录方式',
            trigger: 'change'
          }],
          guardPhone: [{
            required: true,
            message: '请输入监护人联系电话',
            trigger: 'blur'
          }, {
            validator: phoneVt,
            trigger: 'blur'
          }],
          guardIdNumber: [{
            required: true,
            message: '请输入监护人身份证号',
            trigger: 'blur'
          }, {
            validator: idCard,
            trigger: 'blur'
          }],
          guardWechat: [{
            required: true,
            message: '请输入监护人微信号',
            trigger: 'blur'
          }],
       /*   loginUserId: [{
            required: true,
            message: '请输入支付宝账号',
            trigger: 'blur'
          }],*/
          loginUserName: [{
            required: true,
            message: '请输入支付宝姓名',
            trigger: 'blur'
          }],
          loginRelation: [{ required: true, message: "请选择与患儿关系", trigger: "change" }],
          loginIdNumber: [{
            required: true,
            message: '请输入支付宝身份证号',
            trigger: 'blur'
          }, {
            validator: idCard,
            trigger: 'blur'
          }],
        },
      }
    },
    methods: {

      // 根据id查询患儿详情
      helpRequestDataById() {
        getHelpRequestDataById({
          helpReqId: this.helpReqId
        }).then(res => {
          if (res.msgCode == 200) {
            this.detailForm1 = res.responseData;
            if(this.detailForm1.loginAccount)this.hasLoginAccount = this.detailForm1.loginAccount
            this.isAllowStages = res.responseData.isAllowStages;
            this.totalStagesTemp = res.responseData.totalStages;
            this.quotaTypeTemp = res.responseData.quotaType;
            this.curStagesTemp = res.responseData.curStages;
            if (res.responseData.diseasesList && res.responseData.diseasesList.length > 0) {
              // let hasAngle = false;
              this.detailForm1.diseasesIdList = res.responseData.diseasesList.map(d => {
                // hasAngle = hasAngle || d.diseasesId.toLowerCase().indexOf('ts') == 0
                return d.diseasesId;
              })
              // this.isAngleProject = hasAngle;
            }
            this.isAngleProject = this.detailForm1.initialProject == 'AY1002';
            this.isWelfareBabyType = this.detailForm1.isWelfareBaby || this.detailForm1.isAlipay;
            this.isWelfareBabyType = this.isWelfareBabyType == 1 || (this.isWelfareBabyType == 0 && this.detailForm1.loginChannel == 2) ? 1 : 0;
            if (res.responseData.province) {
              let location = [res.responseData.province, res.responseData.city, res.responseData.county];
              this.detailForm1.location = location;
            }
            this.changeDisease(res.responseData.diseasesList, this.isWelfareBabyType, this.isAngleProject, this.detailForm1.initialProject)
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },
      msgCodeValue(text){
        this.detailForm1.captcha = text
      },
      hospitalChange(id, obj){
        this.isAllowStages = obj.isAllowStages
        // if (obj.isAllowStages == 0) {
        //   this.detailForm1.quotaType = this.isAngleProject ? 1 : 0;
        // }
      },
      // // 校验验证码是否匹配
      isCaptchaMatch() {
        // console.log(this.detailForm1.captcha )

        this.$refs['ruleForm3'].validate(async (valid) => {
            // console.log(valid)
            if (valid) {
              //住院流水号校验逻辑
              if (this.detailForm1.isAuto == 1 && this.detailForm1.isShowInHospitalNumber == 1) {
                try {
                  await this.uniqueInHospitalSerialNo();
                } catch (error) {
                  return; // 校验失败时终止流程
                }
              }
              //校验住院号
              if (this.detailForm1.isAuto == 1 && this.detailForm1.isShowInHospitalTime == 1) {
                try {
                  await this.uniqueInHospitalNo();
                  console.log('住院号校验成功');
                } catch (error) {
                  console.error('住院号校验失败:', error);
                  return false; // 中断流程
                }
              };
                if (this.detailForm1.loginAccount) {
                  if (this.hasLoginAccount != '' && this.hasLoginAccount == this.detailForm1.loginAccount) {
                    this.commit()
                  } else {
                    let params = {
                      phone: this.detailForm1.loginAccount,
                      captcha: this.detailForm1.captcha
                    }
                    isCaptchaMatchApi(params).then(res => {

                      if (res.msgCode == 200) {
                        if (res.success) {

                          this.commit()
                        } else {
                          this.$message.error('验证码错误请重新输入')
                        }
                      } else {
                        this.$message.error('验证码验证失败')
                      }
                    })


                  }
                }
              }
            }
          )

          },
      commit() {
        // this.$refs['ruleForm3'].validate((valid) => {
        //   if (valid) {
            this.loading = true

            if (this.detailForm1.diseasesIdList) {
              this.detailForm1.diseasesList = this.detailForm1.diseasesIdList.map(d => {
                return {
                  diseasesId: d
                }
              })
            }
            this.detailForm1.idNumber = this.detailForm1.hasIdNumber == 1 ? this.detailForm1.idNumber : null;
            sbumitRequestApi(this.detailForm1).then(res => {
              this.loading = false
              if (res.msgCode == 200) {
                this.$message.success(res.msg)
                this.closeDetail()
                this.$emit('changeChild')
              } else {
                this.$message.error(res.msg)
              }
            }).catch()
        //   }
        // })
      },
      // 暂存患儿注册
      saveRequest() {
        this.loading = true
        if (this.detailForm1.diseasesIdList) {
          this.detailForm1.diseasesList = this.detailForm1.diseasesIdList.map(d => {
            return {
              diseasesId: d
            }
          })
        }
        this.detailForm1.idNumber = this.detailForm1.hasIdNumber == 1 ? this.detailForm1.idNumber : null;
        saveRequestApi(this.detailForm1).then(res => {
          this.loading = false
          if (res.msgCode == 200) {
            this.detailForm1.locationArr = this.locationArr
            this.detailForm1.isWelfareBabyType = this.isWelfareBabyType
            // var param = JSON.stringify(this.detailForm1)
            // window.localStorage.setItem('saveNewChild', param)
            this.$emit('changeChild')
            this.closeDetail(true)
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },
      //重置
      reuse() {
        let that = this
        let params = {
          helpReqId: this.detailForm1.helpReqId
        }
        this.$confirm('是否确认重启该账号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          parentAccountReuse(params).then(res => {
            if (res.msgCode == 200) {
              this.$message({
                showClose: true,
                message: '账号重启成功',
                type: 'success'
              });
              this.closeDetail(true)
            } else {
              this.$message({
                showClose: true,
                message: '账号重启失败',
                type: 'error'
              });
            }
          })
        })
      },
      // 注册转待申请
      convertToHospitalProxy () {
        this.$confirm('是否确认转换为代申请？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          convertToHospitalProxy({
            helpReqId: this.detailForm1.helpReqId
          }).then(res => {
            if (res.msgCode == 200) {
              this.$message.success('注册代申请成功！');
              this.$emit('changeChild')
              this.closeDetail();
            } else {
              this.$message.error(res.msg)
            }
          })
        });
      },
      closeDetail(a) {
        if (a) {
          this.$emit("update:detailDialog", false);
        } else {
          this.$emit("update:detailDialog", false);
        }
      },
      // 选择分期方式
      changePeriod(e) {
        this.detailForm1.totalStages = this.detailForm1.quotaType == 1 ? 3 : 1;
        this.$forceUpdate()
      },
      // 选择病种
      changeDisease(ids, isWelfareBaby, isAngleProject, initialProject) {
        if (ids && ids.length > 0) {
          this.isWelfareBabyType = isWelfareBaby ? 1 : 0;
          this.isAngleProject = isAngleProject;
          this.initialProject = initialProject;
          this.disabledQuotaType = this.isAllowStages == 0 || initialProject != 'AY1001';
          if (this.disabledQuotaType) {
            this.$set(this.detailForm1, 'quotaType', this.isAngleProject ? 1 : 0);
            this.changePeriod(this.detailForm1.quotaType);
          }
          if (this.isWelfareBabyType) {
            this.detailForm1.loginChannel = '2';
          } else if (!this.detailForm1.loginChannel) {
            this.detailForm1.loginChannel = '1';
          }
        } else {
          this.$set(this.detailForm1, 'quotaType', null);
          this.detailForm1.totalStages = null;
          this.detailForm1.curStages = null;
          this.isWelfareBabyType = null;
          this.isAngleProject = null;
          this.initialProject = null;
          this.detailForm1.loginChannel = null;
        }
        return;
      },

      /**
       * 校验住院流水号
       */
      uniqueInHospitalSerialNo() {
        return new Promise((resolve, reject) => {
          if (!this.detailForm1.inHospitalSerialNo) {
            this.$message.error('住院流水号不能为空！');
            return reject();
          }

          uniqueInHospitalSerialNo({
            hospitalId: this.detailForm1.hospitalId,
            childName: this.detailForm1.childName,
            inHospitalTime: this.detailForm1.inHospitalTime,
            inHospitalSerialNo: this.detailForm1.inHospitalSerialNo,
          }).then(result => {
            if (result.msgCode != 200 || !result.responseData) {
              this.$message.error('住院流水号校验失败！');
              reject();
            } else {
              resolve();
            }
          });
        });
      },

      /**
       * 校验住院号
       */
      uniqueInHospitalNo() {
        return new Promise((resolve, reject) => {
          if (!this.detailForm1.inHospitalNo) {
            this.$message.error('住院号不能为空！');
            return reject('EMPTY_HOSPITAL_NO');
          }
          if(!this.detailForm1.inHospitalTime) {
            this.$message.error('入院时间不能为空！');
            return reject('EMPTY_HOSPITAL_TIME');
          }

          uniqueInHospitalNo({
            hospitalId: this.detailForm1.hospitalId,
            inHospitalNo: this.detailForm1.inHospitalNo,
            inHospitalTime: this.detailForm1.inHospitalTime
          }).then(res => {
            if (res.msgCode == 200) {
              if (res.responseData == 1) {
                resolve(true); // 校验通过
              } else {
                this.$message.error('住院号已存在！')
                reject('DUPLICATE_HOSPITAL_NO');
              }
            } else {
              this.$message.error('res.msg');
              reject('API_ERROR'); // 接口异常
            }
          }).catch(err => reject('NETWORK_ERROR')); // 网络异常
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "src/common/common";
@import "src/common/dialog";
  .r-status {
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    span {
      font-size: 18px;
    }
  }

  //.codeMsg {
  //  width: 4vw;
  //  height: 32px;
  //  position: absolute;
  //  top: 5px;
  //  right: 0px;
  //  font-size: 12px;
  //  font-family: PingFangSC;
  //  font-weight: bold;
  //  color: #FFFFFF;
  //  background: #E8556F;
  //  border-radius: 0.208vw;
  //  line-height: 32px;
  //  text-align: center;
  //}

  @import "src/common/form";

.tiktokClass{
  // 深度修改标签颜色
  /deep/ .el-form-item__label {
    font-weight: bolder;
    color: #E8556F;
  }
  // 深度修改输入框边框
  /deep/ .el-input__inner {
    border: 1px solid #E8556F;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    border: 1px solid #E8556F;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/child/register/ChildDetail.vue